import usePaginatedLogList from "../../../hooks/usePaginatedLogList";
import LogListError from "../../../components/LogListError";
import React, { useEffect, useState } from "react";
import { Button, Select, Table, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import { EyeFilled } from "@ant-design/icons";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL } from "../../../services/apiConstants";
import { formatDate } from "../../../utils/dateFormatter";

const CompanyDeckLogBookList = () => {
  const navigate = useNavigate();
  const { data: filteredData, loading: page_loader, load: loadRecords, pagination, error, retry } =
    usePaginatedLogList(ApiURL.list_deck_logs_com, "logs");
  const [ship_id, set_ship_id] = useState("");
  const [ship_table_list, set_ship_table_list] = useState([]);

  const SHIP_LIST_API = () => {
    try {
      const FORM_DATA = new FormData();
      post(ApiURL.list_ships_view_com, FORM_DATA).then((res) => {
        if (res?.status == true) {
          set_ship_table_list(res?.ships);
          set_ship_id(res?.ships[0]?.id);
          LIST_DECK_LOGBOOK_API(res?.ships[0]?.id);
        }
      });
    } catch (error) {
      console.error("Error fetching ship list:", error);
    }
  };

  const LIST_DECK_LOGBOOK_API = (ship_id) => {
    if (!ship_id) return;
    return loadRecords({ ship_id });
  };

  useEffect(() => {
    SHIP_LIST_API();
  }, []);

  const columns = [
    {
      title: "Id",
      dataIndex: "deck_log_id",
      align: "center",
      key: "deck_log_id",
      sorter: (a, b) => a.deck_log_id - b.deck_log_id,
    },

    {
      title: "Latitude",
      dataIndex: "latitude",
      align: "center",
      key: "latitude",
    },
    {
      title: "Longitude",
      dataIndex: "longitude",
      align: "center",
      key: "longitude",
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (text, record) => formatDate(record?.created_at),
    },
    {
      title: "Updated at",
      dataIndex: "updated_at",
      align: "center",
      key: "updated_at",
      render: (text, record) => formatDate(record?.updated_at),
    },
    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => (
        <Tooltip title="View">
          <Button
            type="primary"
            size="small"
            onClick={() => navigate(`/company-edit-deck-log/${btoa(record.deck_log_id)}`)}
            style={{ marginRight: "5px" }}
            icon={<EyeFilled />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <div>
      <div className="row">
        <div className="col-3">
          <label className="block-label">Select Ship</label>
          <Select
            placeholder="---- Select Ship ----"
            style={{ width: "100%" }}
            value={ship_id}
            onChange={(value) => {
              set_ship_id(value);
              LIST_DECK_LOGBOOK_API(value);
            }}
          >
            {ship_table_list?.length > 0 && (
              <>
                {ship_table_list.map((ship) => (
                  <>
                    {!ship.soft_delete && (
                      <>
                        <Select.Option key={ship.id} value={ship.id}>
                          {ship.vessel_name}
                        </Select.Option>
                      </>
                    )}
                  </>
                ))}
              </>
            )}
          </Select>
        </div>
      </div>
      <div className="row" style={{ padding: "10px" }}>
        <div className="col-3" style={{ marginLeft: "5px", alignSelf: "end" }}>
          <div className="theme-content-title text-left">
            <h3>Deck Logbook Information</h3>
          </div>
        </div>
        <div className="col-3"></div>
        <div className="col-6" style={{ display: "flex", justifyContent: "flex-end" }}>
          <div className="d-flex align-items-center">
            <Button
              type="primary"
              className="save_btn"
              onClick={() => navigate("/view-audit-trail-deck-log")}
            >
              Audit Trail
            </Button>
          </div>
        </div>
      </div>
      <LogListError error={error} retry={retry} />
      <Table
        bordered
        columns={columns}
        dataSource={filteredData}
        pagination={pagination}
        rowKey="deck_log_id"
        loading={page_loader}
        className="custom-table"
      />
    </div>
  );
};

export default CompanyDeckLogBookList;
